import { MyTodoRoutes } from './todo_routes';
import { MyTodoReminderDetailController } from './views/my_todo_reminder_details/my_todo_reminder_details_controller';
import { MyTodoTipDetailController } from './views/my_todo_tip_details/my_todo_tip_details_controller';
import { MyTodosController } from './views/my_todos/my_todos_controller';
import { MyTodosAppointmentDetailsController } from './views/my_todos_appointment_details/my_todos_appointment_details_controller';
import { MyTodosAppointmentRequestDetailsController } from './views/my_todos_appointment_request_details/my_todos_appointment_request_details_controller';
import { MyTodosDetailController } from './views/my_todos_detail/my_todos_detail_controller';
import { MyTodosPlacementTestsController } from './views/my_todos_placement_tests/my_todos_placement_tests_controller';
import { MyTodosStaffTodosDetailController } from './views/my_todos_staff_todos_detail/my_todos_staff_todos_detail_controller';

angular.module('my-todos', []);

angular
  .module('my-todos')
  .controller('MyTodoReminderDetailController', MyTodoReminderDetailController)
  .controller('MyTodosStaffTodosDetailController', MyTodosStaffTodosDetailController)
  .controller('MyTodoTipDetailController', MyTodoTipDetailController)
  .controller('MyTodosController', MyTodosController)
  .controller('MyTodosDetailController', MyTodosDetailController)
  .controller('MyTodosAppointmentDetailsController', MyTodosAppointmentDetailsController)
  .controller('MyTodosAppointmentRequestDetailsController', MyTodosAppointmentRequestDetailsController)
  .controller('MyTodosPlacementTestsController', MyTodosPlacementTestsController)
  .config(MyTodoRoutes);



// WEBPACK FOOTER //
// ./app/lib/my_todos/my_todos_module.ts